module.exports = __webpack_public_path__ + "assets/img/logo-top50.f4f58414.webp";